import searchApiImpl from '../api/search-api';
import type { SearchApi } from './contracts';

export type {
  SearchResultItem,
  SearchApi,
  SearchResultTypeProvider,
  SearchOpenContext,
} from './contracts';
export { getItemTypeAndIdFromUri } from '../util/get-search-filter-url-by-type';
export { registerSearchResultType } from '../services/search-result-type-registry';
export { pdfSearchResultType } from '../types/pdf-search-result-type';
export { useSearchActionPermissions } from '../hooks/use-search-action-permissions';
export { SearchContext, SearchProvider } from '../contexts/search-context';
export { default as Search } from '../components/search-input';
export { default as SearchResults } from '../components/search-results';
export const searchApi: SearchApi = searchApiImpl;
